import { setSelectedCalendarSettingsTab } from "../../store/calendarSettings";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { CalendarSettingsTabBarType } from "../../types/calendarSettings";
import labels from "../../utils/labels";
import ViewTabsWrapper from "../UI/tab/ViewTabsWrapper";
import ViewTab from "../UI/tab/ViewTab";

const CalendarSettingsTabBar = () => {
  const dispatch = useAppDispatch();
  const { selectedCalendarSettingsTab } = useAppSelector(
    (state) => state.calendarSettingsSlice,
  );

  const tabRow: CalendarSettingsTabBarType[] = ["General", "Skill profiles"];

  return (
    <ViewTabsWrapper>
      {tabRow.map((tab) => (
        <ViewTab
          key={tab}
          selected={selectedCalendarSettingsTab}
          onClick={() => {
            dispatch(setSelectedCalendarSettingsTab(tab));
          }}
          tabTypeName={tab}
          displayedTabName={
            tab === "General" ? labels.generalSettings : labels.skillProfiles
          }
        />
      ))}
    </ViewTabsWrapper>
  );
};

export default CalendarSettingsTabBar;
